import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';
import store from './redux/store';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" reverseOrder={false} />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            toastClassName={(context) => {
              switch (context?.type) {
                case "success":
                  return "custom-toast custom-toast-success";

                case "error":
                  return "custom-toast custom-toast-invalid";

                case "info":
                  return "custom-toast custom-toast-pending";

                default:
                  return "custom-toast";
              }
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
